import { Input } from "pages/ActivateInvitePage/Input/Input.component";
import { styled } from "theme/default/styled";

export const SInvitePasswordInput = styled(Input)`
  margin-top: 25px;
  margin-bottom: 10px;
`;
